import LayoutAuth from '@common/LayoutAuth'
import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { AuthService } from '@/services/AuthService'
import s from './index.module.css'
import common from './common.module.css'
import { SetTitlePage } from '@common/SetTitlePage'
import { Button, Form, Input } from 'antd'
import CheckboxViolet from '@UI/New/ChecboxViolet/CheckboxViolet'
import classNames from 'classnames'
import DevPanel from '@/dev/components/DevPanel'
import { Config, Connect, ConnectEvents } from '@vkontakte/superappkit';
import {SETTINGS_TYPES} from "@/constant";
import { MyPdfViewer } from "@common/Probes/Probes";
import { settingApi } from "@/api";
import userAgreementPDF from "./file/userAgreement.pdf"
import privacyPolicyPDF from "./file/privacyPolicy.pdf"
import {IcoRemove} from "@pages/Admin/constsIcon";
import { Link } from 'react-router-dom'
import { VKIcon } from '@/utils/icons'
import AuthorizationAgreementCheck from './components/AuthorizationAgreementCheck/AuthorizationAgreementCheck'
import useAuthorizationAgreementState from './components/AuthorizationAgreementCheck/hooks/AuthorizationAgreementState'
import { useSelector } from 'react-redux'

const DOCUMENTS = {
  userAgreement: userAgreementPDF,
  privacyPolicy: privacyPolicyPDF,
};

const Auth = () => {

  const [settings, setSettings] = useState();
  const hist = useHistory()

  const [loading, setLoading] = useState(false)
  const initError = { status: false, text: '', inputs: {} }
  const [error, setError] = useState(initError)

  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);   

  const fillFormFromQuery = ()=>{
    const params = new URLSearchParams(window.location.search)
    const loginValue = params.get('login') || '';
    const password = params.get('password') || '';

    form.setFieldsValue({
      email: loginValue,
      password: password,
    });

    if (loginValue && password) {
      login({ email: loginValue, password });
    }
  }
  
  useEffect(() => {
    settingApi.getAll()
      .then(response => {
          const items = response.data.filter(item => item.type === SETTINGS_TYPES.GENERAL);
          const generalSettings = {};
          items.forEach(item => Object.assign(generalSettings, { [item.key]: item.value }));
          setSettings(generalSettings);
          fillFormFromQuery()
      });
  }, []);

  const onFieldsChange = () => {
    try {
      // Проверяем, что все поля заполнены и без ошибок
      const values = form.getFieldsValue();
      const errors = form.getFieldsError();
      const isValid = 
        values.email && 
        values.password && 
        errors.every((field) => !field.errors.length);
      setIsFormValid(!!isValid);
    } catch (e) {
      setIsFormValid(false);
    }
  };
  
  const getValueFrom = () => setError(initError)

  const login = async (data) => {
    setLoading(true)
    const res = await AuthService.login(data.email, data.password)
    setLoading(false)

    if (res === 'ok') hist.push('/')
    else setError({ status: true, text: 'Неверная почта или пароль', inputs: { getValueFromEvent: getValueFrom } })
  }

  const onFinish = (data) => login(data)

  const VkAuth = () => {
    Config.init({
      appId: process.env.REACT_APP_VK_APP_ID,
    });

    let url = `${window.location.protocol}//${window.location.hostname}`

    if (window.location.port) {
      url = url + ':' + window.location.port
    }

    Connect.redirectAuth({
      url: `${url}/signup-vk`,
      state: ''
    })
  }
  const [isAgreementAccepted, setIsAgreementAccepted] = useState(true);
  const [isCustomAgreementAccepted, setIsCustomAgreementAccepted] = useAuthorizationAgreementState(true);
  const [openedDocument, setOpenedDocument] = useState(null); // 'userAgreement' | 'privacyPolicy' | null
  const handleOpenDocument = (type) => setOpenedDocument(type);
  const handleCloseDocument = () => setOpenedDocument(null);
  
  const canAuthorize = isCustomAgreementAccepted && isAgreementAccepted

  const isExtendTrainingWithoutLoggingIn = useSelector(store => store.settings.isExtendTrainingWithoutLoggingIn);
  const buttonExtendTrainingWithoutLoggingIn = useSelector(store => store.settings.buttonExtendTrainingWithoutLoggingIn);
  return <LayoutAuth>
    <SetTitlePage title='Авторизация' />
    <div className={common.card}>

      <h2 className={common.title}>Войдите в свой профиль</h2>

      <Form 
        className={common.form} 
        {...{ onFinish, onFieldsChange, form }}>

        <Form.Item 
          name='email' 
          rules={[{ required: true, message: 'Пожалуйста, введите e-mail или номер телефона' }]} 
          {...error.inputs}>
          <Input className={common.input} placeholder='Электронная почта или номер телефона' disabled={loading} />
        </Form.Item>

        <Form.Item 
          name='password' 
          rules={[{ required: true, message: 'Пожалуйста, введите пароль' }]} 
          {...{ ...error.inputs, noStyle: error.status }}>
          <Input.Password className={common.input} placeholder='Пароль' disabled={loading} />
        </Form.Item>

        {error.status && <Form.Item className={s.status}>
          <div className="ant-form-item-explain-error">{error.text}</div>
        </Form.Item>}
        
        <div className={common.agreementWrapper}>
          <div className={common.agreement}>
            <div className={common.checkboxWrapper}>
              <CheckboxViolet
                className={common.checkbox}
                value={isAgreementAccepted}
                setValue={setIsAgreementAccepted}
              />
            </div>
            <div className={common.textAgreement}>
              Принимаю
              <span onClick={() => handleOpenDocument('userAgreement')}>пользовательское соглашение</span> и
              <span onClick={() => handleOpenDocument('privacyPolicy')}>политику конфиденциальности</span>
            </div>
          </div>
          <AuthorizationAgreementCheck 
            confirmed={isCustomAgreementAccepted} 
            onClick={setIsCustomAgreementAccepted}
          />
        </div>

        <Form.Item>
          <div className={common.buttons}>
            <Button 
              htmlType="submit" 
              disabled={!canAuthorize} 
              className={classNames(common.btnSubmit, {[common.active]: isFormValid && canAuthorize})} 
              loading={loading} >
              Войти
            </Button>
            {
              settings?.isDisableloginViaVK === '0' && (
                <Button disabled={!canAuthorize} htmlType="button" className={common.buttonLoginVk} onClick={VkAuth}>
                  Войти через <VKIcon />
                </Button>
              )
            }
           
          </div>
        </Form.Item>

        {
          buttonExtendTrainingWithoutLoggingIn == '1' &&
          isExtendTrainingWithoutLoggingIn == '1' &&
          <div className={common.bottomLinks}>
            <Link className={s.link} to='/payment-without-registration'>Продлить обучение, не авторизуясь</Link>
          </div>
        }

        <div className={common.bottomLinks}>
          {
            settings?.isDisableRegistration === '1' ? <></> : <Link className={common.link} to='/register'>Зарегистрироваться</Link>
          }
          
          <Link className={common.link} to='/restore-password'>Забыли пароль?</Link>
        </div>
      </Form>

      {openedDocument && (
        <div className={common.modal} onClick={(e) => e.target === e.currentTarget && handleCloseDocument()}>
          <div className={common.modalContent}>
            <IcoRemove onClick={handleCloseDocument} className={common.icoRemove} />
            <MyPdfViewer presentation={true} file={DOCUMENTS[openedDocument]} />
          </div>
        </div>
      )}

      {process.env.REACT_APP_DEV_MODE === '1' && <DevPanel login={login} />}
    </div>
  </LayoutAuth>
}

export default Auth